let config = {
    //   baseSso_URL: "https://sso.forgedrift.com", //https://sso.forgedrift.com
    //   baseFida_URL: "https://fida.forgedrift.com/", //"http://dev.wizztech.us:6003/",//https://fida.forgedrift.com//https://fida.wizztech.us //have to check
      // baseSso_URL: "https://sso-stg.flow-insight.com",
      // baseFida_URL: "http://dev.wizztech.us:6003/",
    };
    // export default config
    import axios from "axios";
    export function getUrls() {
      return config;
    }
    
    let isFetched = false;
    export const loadConfig = async () => {
      if (isFetched) return;
      isFetched = true;
      try {
        const protocol = window.location.protocol;
        const key = (protocol == "http:" ? "stg" : "prod");
        //
        const url = {
          prod: "https://resources.wizztech.us/static/client/live.json",
          stg: "https://resources.wizztech.us/static/client/stg.json",
        };
        const server = localStorage.getItem("on") || key;
        localStorage.setItem("on", server);
        const response = await axios.get(url[server]);
        const data = response.data;
        //
        const cfg = {
          baseSso_URL: data?.http?.sso,//data?.http?.sso,
          baseFida_URL:data?.http?.growth,// data?.http?.growth,
          translationLink: data?.static?.growth,
          // sso: data?.http?.sso,
          // fida: data?.http?.growth,
          // inventoryURL: data?.http?.ebuyings,
          // ...config,
        };
        config = cfg;
        isFetched = true;
        return config;
      } catch (error) {
        isFetched = false;
        console.error("There was a problem with the axios request:", error);
      }
    };